<template>
  <div class="rescueEnd">
    <div
      id="container"
      :class="showInfo ? 'containerSmall' : 'container'"
    />
    <van-search
      v-model="search"
      placeholder="请输入搜索关键词"
      shape="round"
      class="search"
      input-align="center"
      @input="changeSearch"
    />
    <div
      class="info"
      v-show="showInfo"
    >
      <div
        v-for="(item, index) in infoItem"
        :key="index"
        class="infoItem"
        @click="jumpPosition(index)"
      >
        <van-button
          type="info"
          class="submit"
          @click="backToRescue(item.name,item.location.lng,item.location.lat,item)"
        >选择</van-button>
        <p class="infoItemName">{{ item.name.length>20? item.name.slice(0,20)+'...':item.name }}</p>
        <p class="infoItemAddress">{{ item.address.length>40? item.address.slice(0,38)+'...':item.address }}</p>
      </div>
      <van-empty
        v-if="infoItem.length === 0"
        image="search"
        description="请输入详细的省市地名进行搜索"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
  data() {
    return {
      baseLng: 116.397428,
      baseLat: 39.90923,
      search: '',
      map: '',
      marker: '',
      cityCode: '',
      showInfo: false,
      infoItem: [],
      // phone: '',
      // carNo: '',
      // startLat: '',
      // startLng: '',
      // contactAddress: '',
      // currentTypeIndex: ''
      formData: {},
      type: ''
    };
  },
  computed: {
    ...mapState(['accidentRescueInfo'])
  },
  mounted() {
    this.formData = this.$store.state.accidentRescueInfo;
    console.log(this.formData, 'form');
    this.type = this.$route.query.type || '';
    this.getPosition();
  },
  methods: {
    ...mapMutations([
      'setAccidentRescueInfo'
    ]),
    backToRescue(contactAddress, startLng, startLat, item) {
      console.log(item, 'item');
      this.$router.go(-1);
      console.log(this.type, 'type');
      const geocoder = new AMap.Geocoder({
        radius: 10 // 范围，默认：500
      });
      if (this.type === 'start') {
        this.formData.contactAddress = contactAddress;
        this.formData.longitude = startLng;
        this.formData.latitude = startLat;
        geocoder.getAddress(new AMap.LngLat(startLng, startLat), (status, result) => {
          console.log(status, 'status');
          console.log(result, 'result');
          if (status === 'complete' && result.regeocode) {
            const adcode = result.regeocode.addressComponent.adcode;
            const province = adcode.slice(0, 2);
            const city = adcode.slice(0, 4);
            console.log(province, 'province');
            console.log(city, 'city');
            this.formData.area = adcode;
            this.formData.city = `${city}00`;
            this.formData.province = `${province}0000`;
          }
        });
      } else {
        this.formData.destination = contactAddress;
        this.formData.destLongitude = startLng;
        this.formData.destLatitude = startLat;
        geocoder.getAddress(new AMap.LngLat(startLng, startLat), (status, result) => {
          console.log(status, 'status');
          console.log(result, 'result');
          if (status === 'complete' && result.regeocode) {
            const adcode = result.regeocode.addressComponent.adcode;
            const province = adcode.slice(0, 2);
            const city = adcode.slice(0, 4);
            console.log(province, 'province');
            console.log(city, 'city');
            this.formData.destArea = adcode;
            this.formData.destCity = `${city}00`;
            this.formData.destProvince = `${province}0000`;
          }
        });
      }
      this.setAccidentRescueInfo(this.formData);
    },
    changeSearch(val) {
      const _this = this;
      AMap.service(['AMap.PlaceSearch'], function() {
        var placeSearch = new AMap.PlaceSearch({
          pageSize: 30, // 单页显示结果条数
          pageIndex: 1, // 页码
          city: _this.cityCode, // 兴趣点城市
          // city: _this.search, // 兴趣点城市
          citylimit: false
          // map: _this.map
          // type: '汽车服务|汽车销售|汽车维修|摩托车服务|餐饮服务|购物服务|生活服务|体育休闲服务|医疗保健服务|住宿服务|风景名胜|商务住宅|政府机构及社会团体|科教文化服务|交通设施服务|金融保险服务|公司企业|道路附属设施|地名地址信息|公共设施'
        });
        placeSearch.search(val, (status, result) => {
          console.log(result, 'result');
          _this.infoItem = result.poiList.pois;
          _this.showInfo = true;
          _this.jumpPosition(0);
        });
      });
      this.moveEnd;
    },
    jumpPosition(index) {
      this.map.setCenter([this.infoItem[index].location.lng, this.infoItem[index].location.lat]);
      this.marker.moveTo(new AMap.LngLat(this.infoItem[index].location.lng, this.infoItem[index].location.lat), 1000000);
    },
    async getLocationList(val) {},
    async getMap() {
      const _this = this;
      this.map = new AMap.Map('container', {
        resizeEnable: true, // 是否监控地图容器尺寸变化
        zoom: 18, // 初始化地图层级
        center: [_this.baseLng, _this.baseLat] // 初始化地图中心点
      });
      this.marker = new AMap.Marker({
        position: new AMap.LngLat(_this.baseLng, _this.baseLat),
        draggable: true,
        animation: 'AMAP_ANIMATION_BOUNCE'
      });
      const geocoder = new AMap.Geocoder({
        radius: 10 // 范围，默认：500
      });
      AMap.plugin('AMap.Autocomplete', function() {
        // 异步加载插件
      });
      this.map.add(_this.marker);
      function moveEnd() {
        console.log('haha');
        const center = _this.map.getCenter();
        geocoder.getAddress(new AMap.LngLat(center.lng, center.lat), (status, result) => {
          if (status === 'complete' && result.regeocode) {
            const address = result.regeocode.formattedAddress;
            console.log(result);
            // 切换县区级到市级
            _this.cityCode = result.regeocode.addressComponent.adcode.slice(0, 4) + '00';
            console.log(_this.cityCode);
            console.log(address);
            // _this.contactAddress = address;
            let keywords = address;
            if (
              _this.type === 'start' && _this.formData.contactAddress
            ) {
              keywords = _this.formData.contactAddress;
            } else if (_this.type === 'end' && _this.formData.destination) {
              keywords = _this.formData.destination;
            }
            _this.changeSearch(keywords);
          } else {
            // log.error('根据经纬度查询地址失败')
            console.log('根据经纬度查询地址失败');
          }
        });
      }
      moveEnd();
      //   map.on('moveend', moveEnd);
    },
    async getPosition() {
      const _this = this;
      const mapObj = new AMap.Map('container');
      console.log(mapObj, 'mapObj');
      mapObj.plugin('AMap.Geolocation', () => {
        const geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认:true
          timeout: 10000, // 超过10秒后停止定位，默认：无穷大
          maximumAge: 0, // 定位结果缓存0毫秒，默认：0
          convert: true, // 自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          'showButton': true, // 显示定位按钮，默认：true
          'buttonPosition': 'LB', // 定位按钮停靠位置，默认：'LB'，左下角
          buttonOffset: new AMap.Pixel(10, 20), // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          showMarker: true, // 定位成功后在定位到的位置显示点标记，默认：true
          showCircle: true, // 定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true, // 定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: true // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        });
        console.log(geolocation, 'geolocation');
        mapObj.addControl(geolocation);
        geolocation.getCurrentPosition((status, result) => {
          console.log(status, '----');
          if (status == 'complete') {
            console.log(result);
            _this.baseLng = result.position.lng;
            _this.baseLat = result.position.lat;
            console.log(_this.baseLng, _this.baseLat);
            _this.getMap();
          } else {
            console.log(result, 'error');
          }
        });
        AMap.event.addListener(geolocation, 'complete', onComplete);
        AMap.event.addListener(geolocation, 'error', onError);

        function onComplete(data) {
          // data是具体的定位信息
        }

        function onError(data) {
          // 定位出错
        } // 返回定位出错信息
      });
    }
  }
};
</script>

<style lang="less" scoped>
.rescueEnd {
  width: 7.5rem;
  height: 100vh;

  font-family: PingFangSC-Regular;
  font-weight: 300;
   span{
    vertical-align:baseline
}
  .container {
    width: 100%;
    height: 100%;
  }
  .containerSmall {
    width: 100%;
    height: 10rem;
  }
  .search {
    position: absolute;
    top: 0;

    width: 7.5rem;
  }
  .info {
    position: absolute;
    bottom: 0;

    overflow-y: scroll;

    width: 100%;
    height: 6.5rem;

    border-top: 0.01rem #E6E6E6 solid;
    background: #fff;
    .infoItem {
      width: 6.88rem;
      height: 0.93rem;
      padding:0.32rem;
      padding-right: 0.32rem;

      border-bottom: 0.01rem #E6E6E6 solid;
      .infoItemName {
        float: left;

        width:4rem;

        color: #383838;

        font-family: PingFangSC-Medium;
        font-size: 0.32rem;
      }
      .infoItemAddress{
          float: left;

          width:4rem;
          margin-top:0.13rem;

          color: #808080;

          font-size: 0.24rem;
      }
      .submit{
          float:right;

          vertical-align:middle
      }
    }
  }
}
</style>
